import React, { Component, Fragment, createRef } from "react";
import AppContext from "../../contexts/AppContext";
import LanderHeader from "./include/LanderHeader";
import Footer from "./include/Footer";
import SubscriberForm from "./include/SubscriberForm";
import StartTrialButton from "./include/StartTrialButton";
import StartTrialButtonTwo from "./include/StartTrialButtonTwo";
import Testimonial from "./include/Testimonial";
import VideoContent from "./include/VideoContent";
import HomeSearch from "./include/HomeSearch";
import "./include/HomeBanner.css";

export class Home extends Component {	
	
	scrollDiv = createRef();
	
	state = { 
         thePosition: false,
		 video: false,
		 animate: false,
		 prompt: this.context.state.getParameterByName('prompt'),
		 mobileButtonVisible: false,
         videoId: "1",		 
	};

	componentDidMount() {
		this.context.state.updateMetaData('home');
		if(this.state.prompt === 'signup')
        {
            this.pulse();
        }	
		window.addEventListener('scroll', (e) => this.onScroll(e), true);		
	}
	  
	componentWillUnmount() {		
		window.removeEventListener('scroll', (e) => this.onScroll(e), true);
	}
	
	scrollToTop = () => {		
		this.scrollDiv.current.scrollIntoView({ behavior: "smooth" });
		this.pulse();
	};
	
	pulse = () => {
		this.setState({ animate: true });
		setTimeout(function() {
			this.setState({ animate: false });
		}.bind(this), 4000);
	}
	
	toggleVideo = Id => {
        this.setState({ video: this.state.video === true ? false : true, videoId: Id });
		console.log(Id);
	};

	onScroll = e => {
		let elmnt = document.getElementById("call-to-action-button-show-container");
		let height_diff = elmnt.offsetTop - elmnt.getBoundingClientRect().top; 
		
		// only work for mobile
		if(this.context.state.isMobile())
		{
			let element = e.target
			//console.log(element);
			//console.log(element.scrollHeight - element.scrollTop, element.clientHeight);
			//console.log(height_diff);
            //1500 
			//1400 

			//if (element.scrollHeight - element.scrollTop < 10960) { 
			if((height_diff >= 450 && window.innerWidth > 320) || (height_diff >= 450 && window.innerWidth <= 320))	{
				// do something at end of scroll
				this.setState({ mobileButtonVisible: true });
			}
			else{
				this.setState({ mobileButtonVisible: false });
			}
		}	
		
	};
	loadPortfolio =() =>{
		window.location = '/tools/portfolios';
	}
	loadPostJob = ()=>{
		if(!this.context.state.isAuth()){
			window.location = '/register?next=post-job' ;
		}else{
			window.location = '/employer/jobListing/create'
		}
		
	}
	render() {
		
		return (
            <Fragment>
                <div className="lander-wrapper">
				    <LanderHeader prompt={this.state.prompt}></LanderHeader>
					<section className="below-header">
					    <div className="container">
						    <p className="text-center m-0"><span className="font-weight-bold text-white">ProWriter:</span> The #1 Source For Professional Freelance Writers</p>
						</div>
					</section>
                    {/* <section className="banner" ref={this.scrollDiv}>
                        <div className="container">
				    	    <div className="sub-container mx-auto">
				    	        <div className="row align-items-end">
				    		        <div className="col-lg-6 mt-lg-0 first-col">
				    		    	    <h3 className="mb-4 text-center">
										    <span className="d-block font-weight-bold f1">Land Your Dream</span>
											<span className="d-block font-weight-bold f2 mt-sm-3 mt-2 mb-sm-4 mb-3">Writing Jobs</span>
											<span className="d-block f3">With ProWriter’s Freelance Writer</span>
											<span className="d-block f3">
											    <span className="font-weight-bold">Jobs Board</span>, 
												<span className="font-weight-bold">Tools</span>, 
												And <span className="font-weight-bold">Education</span>
											</span>	
										</h3>
				    		    		<p className="position-relative mb-3 mx-auto text-center">
				    		    		    <span className="font-weight-bold">(Created By Employers Who've Hired Over 1,000 Writers!)</span> 
				    		    		    <img className="w-auto position-absolute d-lg-block d-none" src="/images/banner-arrow.png" alt="banner-arrow" loading="lazy"/>
				    		    		</p>
				    		    		<div className= {this.state.animate ? `mb-lg-4 question-block w-100 animate__animated animate__pulse animate__infinite animate__slow	2s` : `mb-lg-4 question-block w-100`}>
											<SubscriberForm></SubscriberForm>
											<StartTrialButtonTwo title="Start Free 14 Day Trial Now" clsName='d-block mx-auto button position-relative px-md-4 px-2'></StartTrialButtonTwo>
				    		    		</div>
				    		    	</div>
				    		    	<div className="col-lg-5 d-lg-none d-block">
				    		    	    <img className="w-auto ml-md-auto mx-auto mt-md-0 mt-3" src="/images/new-banner.png" alt="logo" loading="lazy"/>
				    		    	</div>
				    		    </div>
				    		</div>	
				    	</div>
                    </section> */}
					<section className="lander-banner">
                    <div className="container">
                        <div className="sub-container mx-auto">
							<div className="col-lg-6 col-md-6 mx-auto">
                                <div className="inner-banner-content text-center">
									<h1>Freelance Writing Jobs Board for Professional Writers</h1>
									<HomeSearch/>
									<div className="portfolio-content mb-5">
										<a className="font-weight-bold" onClick={this.loadPortfolio}>Apply with a portfolio</a>
										<span className="pl-2">- 10x your chances of getting hired</span>
									</div>
									<div className="employer-content">
										<span className="pr-2">Employers:</span>
										{ (!this.context.state.isAuth() || (this.context.state.isAuth() && this.context.state.user.type === "employer")) ?
										<a className="font-weight-bold" onClick={this.loadPostJob} >Post a Job</a>
										:''}
									</div>
								</div>
							</div>
						</div>
					</div>						
					</section>
				    <section className="partners">
				        <div className="container">
				    	    <h3 className="text-center mb-5">ProWriters Get Hired At:</h3>
				    		<div className="row align-items-center w-50 mx-auto justify-content-center">
				    		    <div className="col-lg-2 col-sm-2 col-4">
				    			    <img src="/images/TravelAwaits.png" alt="TravelAwaits" width="80" height="60"/>
				    			</div>
				    			<div className="col-lg-2 col-sm-2 col-4">
				    			    <img src="/images/StudyLogo.png" alt="StudyLogo" width="142" height="30"/>
								</div>
								<div className="col-lg-2 col-sm-2 col-4">
				    			    <img src="/images/ScreenRant.png" alt="ScreenRant" width="80" height="50"/>
				    			</div>
				    			<div className="col-lg-2 col-sm-2 col-4 mt-sm-0 mt-4">
				    			    <img src="/images/Business2Community.png" alt="Business2Community" width="80" height="34"/>
				    			</div>
								<div className="col-lg-2 col-sm-2 col-4 mt-sm-0 mt-4">
				    			    <img src="/images/MoneyWise.png" alt="MoneyWise" width="80" height="16"/>
				    			</div>
				    		</div>
				    	</div>
				    </section>
				    <section className="video">
				        <div className="container">
				    	    <h3 className="text-center mx-auto mb-3">What Makes ProWriter Different?</h3>
				    		<p className="text-center mx-auto mb-5">We know you've checked out dozens of freelance writing communities and tools, only to be left with no more writing jobs than when you started. Here's why we're something completely different...</p>
				    		<div className="video-container mx-auto position-relative">
							    <a onClick={() => this.toggleVideo("1")} className="video-play-button" href="#"><span></span></a>
								<img src="/images/ProWriterSalesImage.png" alt="poster-image" width="700" height="300"/>
                            </div>
				    		<p className="text-center mx-auto mt-5 mb-5">We're employers who built the way for freelance writers like you to become irresistibly hirable. Start your journey below!</p>
				    		<div className="mb-4 d-flex justify-content-center">
				    		    <div className= "mb-lg-4 question-block w-100">
									{/*<SubscriberForm></SubscriberForm>*/}
									<StartTrialButtonTwo title="Create Your Free Account Now" clsName='d-block button mx-auto position-relative px-md-4 px-2'></StartTrialButtonTwo>
				    		    </div>
				    		</div>
				    		<img className="w-50 mx-auto" width="622" height="256" src="/images/point-left.png" alt="point-left" loading="lazy"/>
				    	</div>
				    </section>
				    <section className="question-block">
				        <div className="container">
				    	    <div className="sub-container mx-auto">
				    	        <div className="row align-items-center" id="call-to-action-button-show-container">
				    		        <div className="col-md-6 order-md-1 order-2">
				    		    	    <img className="w-100 mx-md-0 mx-auto" src="/images/q1.png" width="428" height="431" alt="image" loading="lazy"/>
				    		    	</div>
				    		    	<div className="col-md-6 order-md-2 order-1">
				    		    	    <img className="question-img w-auto mb-3" width="65" height="65" src="/images/question1.png" alt="image" loading="lazy"/>
				    		    		<h3 className="mb-3">ProWriter Helps Writers Like You Earn More Gigs And Higher Payouts</h3>
				    		    		<p className="mb-4">Yes, ProWriter gives you the must-have tools, strategies, and skills you need to Find, Apply, and Land high-paying writing gigs.</p>
				    		    		<ul>
				    		    		    <li className="position-relative pl-4 mb-2"><i className="position-absolute fa fa-check"></i>Exclusive jobs board to help you land your dream writing gigs!</li>
                                            <li className="position-relative pl-4 mb-2"><i className="position-absolute fa fa-check"></i>Hard skills training to help you earn the highest payouts!</li>
                                            <li className="position-relative pl-4 mb-2"><i className="position-absolute fa fa-check"></i>Marketing tools to help you sell yourself, skills, and experience!</li>
                                            <li className="position-relative pl-4 mb-2"><i className="position-absolute fa fa-check"></i>Career management insights to help you level-up your writing career!</li>
                                        </ul>
				    		    	</div>
				    		    </div>
								<img className="w-50 mx-auto" src="/images/point-right.png" width="570" height="137" alt="point-right" loading="lazy"/>
				    		    <div className="row align-items-center">
				    		        <div className="col-md-6 order-2">
				    		    	    <img className="w-100 ml-md-auto mx-md-0 mx-auto" src="/images/jobs_board.png" alt="image" loading="lazy" width="558" height="476"/>
				    		    	</div>
				    		    	<div className="col-md-6 order-1">
				    		    	    <img className="question-img w-auto mb-3" src="/images/question4.png" alt="image" width="65" height="65" loading="lazy"/> 
				    		    		<h3 className="mb-3">Find And Land Well-Paying Gigs Without Wasting Hours Of Time</h3>
				    		    		<p className="mb-4">Tired of combing through countless job boards only to find low-paying, uninteresting, and scammy-sounding writing jobs? We did too. That's why we designed the ProWriter jobs board to curate the web's best writing opportunities. Easily apply and manage your writing applications all within your account.</p>
				    					<StartTrialButtonTwo title="Find Writing Jobs Now!" clsName='d-md-block d-none position-relative px-md-4 px-2'></StartTrialButtonTwo>
				    		    	</div>
				    		    </div>
				    		    <img className="w-50 mx-auto" width="570" height="137" src="/images/point-right.png" alt="point-right" loading="lazy"/>
				    		    <div className="row align-items-center">
				    		        <div className="col-md-6 order-md-1 order-2">
				    		    	    <img className="w-100 ml-md-auto mx-md-0 mx-auto" width="558" height="214" src="/images/courses.png" alt="image" loading="lazy"/>
				    		    	</div>
				    		    	<div className="col-md-6 order-md-2 order-1">
				    		    	    <img className="question-img w-auto mb-3" width="65" height="65" src="/images/question2.png" alt="image" loading="lazy"/>
				    		    		<h3 className="mb-3">Learn the critical skills employers expect from hired writers</h3>
				    		    		<p className="mb-4"> ProWriter helps you master the most in-demand writing skills that top employers are actively searching freelance writers to fill... while connecting you with the highest level of clients as we work diligently to weed out the kind of employers you want to avoid at all costs.</p>
				    					<StartTrialButtonTwo title="Learn Critical Skills Now!" clsName='d-md-block d-none position-relative px-md-4 px-2'></StartTrialButtonTwo>						    		
				    		    	</div>
				    		    </div>
				    			<img className="w-50 mx-auto" width="570" height="233" src="/images/point-left.png" alt="point-left" loading="lazy"/>
				    			<div className="row align-items-center">
				    		        <div className="col-md-6 order-2">
				    		    	    <img className="w-100 mx-md-0 mx-auto" width="558" height="444" src="/images/portfolio.png" alt="image" loading="lazy"/>
				    		    	</div>
				    		    	<div className="col-md-6 order-1">
				    		    	    <img className="question-img w-auto mb-3" width="30" height="30" src="/images/question3.png" alt="image" loading="lazy"/>
				    		    		<h3 className="mb-3">Become A Valuable Brand, Not Just A Freelancer</h3>
				    		    		<p className="mb-4">We're employers, so we know who employers want to hire. Put simply, we want writers who can provide value beyond words on the page. That's why we built ProWriter to provide writers like you the marketing tools and skills to gain and showcase your value to employers so you earn more gigs and higher payouts.</p>
				    		    		<StartTrialButtonTwo title="Claim Your Portfolio Now!" clsName='d-md-block d-none position-relative px-md-4 px-2'></StartTrialButtonTwo>									
				    		    	</div>
				    		    </div>
				    		</div>	
				    	</div>
				    </section>
				    <section className="trust">
				        <div className="container">
				    	    <img className="w-50 ml-md-auto mx-md-0 mx-auto mb-3" width="495" height="254" src="/images/point-left-2.png" alt="point-left" loading="lazy"/>
				    		<div className="sub-container mx-auto">
				    		    <h3 className="text-center mb-3">How Can You Be 100% Sure ProWriter Is A Good Fit For You?</h3>
				    			<div className="text-center"><span className="d-inline-block text-center mb-5 p-3">ProWriter Is Right For You If:</span></div>
				    			<ul className="pl-4">
				    		        <li className="position-relative pl-4 pr-4 mb-4"><i className="position-absolute fa fa-check"></i>You are ready to say goodbye forever to low paying and low-quality writing clients who don’t value your skills.</li>
                                    <li className="position-relative pl-4 pr-4 mb-4"><i className="position-absolute fa fa-check"></i>You want to grow your writing skills in an innovative, encouraging, and supportive environment.</li>
                                    <li className="position-relative pl-4 pr-4 mb-4"><i className="position-absolute fa fa-check"></i>You are serious about building a real business as a professional writer.</li>
                                    <li className="position-relative pl-4 pr-4 mb-4"><i className="position-absolute fa fa-check"></i>You understand the advantage of having a mentor teach you exactly what employers are looking for and how you can become their go to writer.</li>
				    				<li className="position-relative pl-4 pr-4 mb-4"><i className="position-absolute fa fa-check"></i>You know how much real value you bring to employers and are ready to finally be paid what you deserve.</li>
                                    <li className="position-relative pl-4 pr-4 mb-4"><i className="position-absolute fa fa-check"></i>You appreciate having the flexibility and financial freedom to fully enjoy life on your terms.</li>
                                    <li className="position-relative pl-4 pr-4 mb-4"><i className="position-absolute fa fa-check"></i>You are ready to join the top 5% of highest earning writers in the world.</li>
                                </ul>
				    			<div className="mb-4 d-flex justify-content-center">
				    		        <div className= "mb-lg-4 question-block w-100">
										{/*<SubscriberForm></SubscriberForm>*/}
										<StartTrialButtonTwo title="Create Your Free Account Now"  clsName='d-block button mx-auto position-relative px-md-4 px-2'></StartTrialButtonTwo>
				    		    	</div>
				    		    </div>
				    			<img className="w-100 mx-auto" width="458" height="254" src="/images/point-left-2.png" alt="point-left" loading="lazy"/>
				    		</div>
				    	</div>
				    </section>
				    <section className="demo bg-white">
				        <div className="container">
				    	    <div className="sub-container mx-auto">
				    	        <h3 className="mb-3 text-center">Watch Demo:</h3>
				    		    <p className="sub mb-5 mx-auto text-center">Take A Peek Behind The Curtain Of How ProWriter Is Helping Writers All Around The World Advance Their Freelance Writing Career.</p>
				    		    <div className="video-container mx-auto mb-4 position-relative">
								    <a onClick={() => this.toggleVideo("2")} className="video-play-button" href="#"><span></span></a>
                                    <img src="/images/ProWriterDemoImage.png" alt="poster-image" width="600" height="300"/>
                                </div>
				    		    <div className="row align-items-center mt-5 case-study">
				    		        <div className="col-md-3">
				    		    	    <img className="w-auto mx-auto" width="226" height="203" src="/images/JeanetteReubPic.png" alt="case-study" loading="lazy"/>
				    		    	</div>
				    		    	<div className="col-md-9 mt-md-0 mt-5">
				    		    	    <h3 className="mb-3">Case Study</h3>
				    		    		<p className="pr-md-5">Being a ProWriter Member helped me assemble a solid portfolio of paid work. As someone who hopped around from "exposure"-paying clients, international contracts, and domestic work that offered breadcrumbs in compensation, Dusten and Dave boosted my confidence in not only how much my work was really worth, but in my abilities as a writer, overall.</p>
                                        <p className="pr-md-5">Their feedback always helped me improve and encouraged me to grow. Of all the myriad job experiences I've had, working for Dusten and Dave has been the most laudable.</p>
				    		    	</div>
				    		    </div>
				    		    <StartTrialButtonTwo title="Become a ProWriter Now!" clsName='d-md-block case-study-btn text-center d-none mx-auto mt-4 position-relative px-md-4 px-2'></StartTrialButtonTwo>						
				    		</div>	
				    	</div>
				    </section>
				    <section className="testimonial">
				        <div className="container">
				    	    <div className="sub-container mx-auto">
				    	        <h3 className="text-center mb-5 mx-auto">What Our Members Are Saying</h3>
				    		    <div className="row">
				    		        <div className="col-md-4">
				    		    	    <Testimonial image="PiperGourley.png" name="Piper Gourley" title="" text="Dusten and Dave are some of the most trustworthy, reliable, and resourceful people in the freelancing industry. ProWriter helped me develop a clearer grasp on the realities of the freelancing market. I feel more prepared than many peers at my level to take on the work of recruiting clients and writing to various niches." className="mb-3"></Testimonial>
				    					<Testimonial image="JessicaLakritz.png" name="Jessica Lakritz" title="" text="My skills as a writer have significantly improved thanks to ProWriter. It’s helped me to write clearly and concisely about pretty much anything. Plus, I’ve also learned SEO skills which have helped me to get my dream clients!" className="mb-3"></Testimonial>
				    					<Testimonial image="MarissaBlackman.png" name="Marissa Blackman" title="" text="ProWriter allowed me to have much more regular work with regular feedback on my work from a trusted source. This really helped me to sharpen my skills when I was a newer writer." className="mb-3"></Testimonial>
									</div>
				    		    	<div className="col-md-4">
				    		    	    <Testimonial image="BlakeTaylor.png" name="Blake Taylor" title="" text="Since writing for Dusten and Dave, I earned an opportunity to write content for Snoop Dogg's cannabis-based website MERRY JANE. There is no question that my portfolio built with ProWriter was directly responsible for the new gig." className="mb-3"></Testimonial>
										<Testimonial image="CaseyCavanagh.png" name="Casey Cavanagh" title="" text="As a result of working with the team at ProWriter, I feel much more confident in both my skills and prospects as a writer. Dusten and Dave have created an environment where you always feel comfortable coming to them with both career and content-related questions. which, in turn, has helped enhance my editorial capabilities on the whole." className="mb-3"></Testimonial>
										<Testimonial image="MandyLutman.png" name="Mandy Lutman" title="" text="I found Dusten and Dave very approachable and easy to talk to when it comes to progressing a role, getting more work, or just a general chat about ideas. It's refreshing to have friendly freelance management that always tries their best to do everything they can for the team." className="mb-3"></Testimonial>
				    				</div>
				    		    	<div className="col-md-4">
				    		    	    <Testimonial width="40" height="40" image="KasyLong.png" name="Kasy Long" title="" text="Since becoming a ProWriter Member, I have started writing entertainment articles for the popular website Screen Rant (through Valnet, Inc.). In addition, I have written education-based content for Study.com, one of the largest online learning platforms." className="mb-3"></Testimonial>
				    					<Testimonial image="default-testi.png" name="Sam Mire" title="" text="Thanks to ProWriter, I've developed a better understanding of what readers want, and how important it is to pay attention to the prevailing SEO and content trends from an editorial standpoint. I also appreciated the responsiveness to questions and concerns, as this is always an indication that I am valued as a contractor." className="mb-3"></Testimonial>
										<Testimonial image="DeborahC.png" name="Deborah C" title="" text="Dusten and Dave at ProWriter gave my freelance career the boost it needed. They helped me improve my writing skills, editing skills, client customer service skills, and my understanding of the freelance market. I never hesitated to ask them a question when I needed it and their answers were on point. Always. Because of them, I have a thriving, fulfilling freelance writing career that pays well and allows me the flexibility I need to live the rest of my life." className="mb-3"></Testimonial>
				    		    	</div>
				    		    </div>
				    		</div>	
				    	</div>
				    </section>
				    <section className="trust2">
				        <div className="container position-relative">
				    	    <div className="sub-container mx-auto">
				    			<div className="text-container">
				    		        <h3 className="mb-3 text-white">Start Your Journey Toward A Writing Career Now!</h3>
				    		    	<p className="mb-5 position-relative">
									Sign up right now and get full, immediate access to ProWriter’s library of resources and marketing tools. Heck, you might even land your first paying client today!
				    					<img className="w-auto position-absolute" src="/images/banner-arrow.png" alt="banner-arrow" loading="lazy"/>
				    				</p>
				    		    	<div className= "mb-lg-4 question-block w-100">
										{/*<SubscriberForm></SubscriberForm>*/}
										<StartTrialButtonTwo title="Create Your Free Account Now" clsName='d-block button mx-md-0 mx-auto position-relative px-md-4 px-2'></StartTrialButtonTwo>
				    		    	</div>
				    		    </div>
				    		</div>	
				    	</div>
				    </section>
				    <section className="faq">
				        <div className="container">
				    	    <div className="sub-container mx-auto">
				    	        <img className="arrow position-relative mb-4" width="490" height="251" src="/images/point-right-2.png" alt="point-right" loading="lazy"/>
				    		    <h3 className="mb-5 text-center">Here Are A Few FAQs We Get A Lot:</h3>
				    		    <div className="row">
				    		        <div className="col-md-6 pr-md-5">
				    		    	    <h4 className="mb-3 pl-5 position-relative"><i className="position-absolute fa fa-question-circle"></i>Does ProWriter hire writers for assignments?</h4>
				    		    		<p className="pb-4 mb-4">No, ProWriter itself does not employ writers and is not a content marketplace.</p>
				    					<h4 className="mb-3 pl-5 position-relative"><i className="position-absolute fa fa-question-circle"></i>What does a ProWriter membership give me?</h4>
				    		    		<p className="pb-4 mb-4">We provide writers with educational materials (courses, articles, mini-lessons, and more), marketing tools (a free writer portfolio designed with employers in mind), a jobs board (hand-picks writing gigs from all over the web, and hosts unique jobs), and other supportive community functions.</p>
				    					<h4 className="mb-3 pl-5 position-relative"><i className="position-absolute fa fa-question-circle"></i>Why do you charge for this service?</h4>
				    		    		<p className="pb-4 mb-4">ProWriter’s technology and content library are powered by a small team of passionate entrepreneurs. In order to maintain and update the tech so that it always serves our community, and in order to keep producing content that helps more writers succeed, we need help keeping the lights on!</p>
										<h4 className="mb-3 pl-5 position-relative"><i className="position-absolute fa fa-question-circle"></i>Can I use ProWriter if I’ve never gotten a writing job?</h4>
				    		    		<p className="pb-4 mb-4">Yep! ProWriter’s tools and materials are ideal for writers within the first 12-18 months of their career. It’s designed for anyone taking their first steps into freelance writing, or for writers who have been at it for a little while but feel stuck in a rut, and aren’t seeing the success they want yet. See for yourself!</p>
				    				</div>
				    		    	<div className="col-md-6 pl-md-5">
				    				    <h4 className="mb-3 pl-5 position-relative"><i className="position-absolute fa fa-question-circle"></i>Do overseas writers qualify for ProWriter?</h4>
				    		    		<p className="pb-4 mb-4">Of course! ProWriter’s tools and materials are available to any aspiring writer in the world. Please note that in order to qualify for portfolio verification, an internal feature which unlocks more features in ProWriter, every writer must pass an English competency test.</p>
				    					<h4 className="mb-3 pl-5 position-relative"><i className="position-absolute fa fa-question-circle"></i>I’m still not sold. Can I try it for free?</h4>
				    		    		<p className="pb-4 mb-4">We offer a drastically reduced trial price of just $1 for 7 days of everything ProWriter has to offer. If you're not convinced after 7 days then you can cancel your account with no extra charge.</p>
				    					<h4 className="mb-3 pl-5 position-relative"><i className="position-absolute fa fa-question-circle"></i>If I have questions, is there someone I can talk to?</h4>
				    		    		<p className="pb-4 mb-4">Yes! We have a first-class support team who can answer your questions 24 hours a day, 7 days a week! Just click on the chat button at the bottom of any of our pages or email <a href="mailto:support@ProWriter.co">support@ProWriter.co</a>.</p>
				    					<h4 className="mb-3 pl-5 position-relative"><i className="position-absolute fa fa-question-circle"></i>If I don't like ProWriter, how do I cancel?</h4>
				    		    		<p className="pb-4 mb-4">Simply log in to your account, click on your account settings and click "cancel my account". No need to call, email, or talk to anyone!</p>
										<h4 className="mb-3 pl-5 position-relative"><i className="position-absolute fa fa-question-circle"></i>If I cancel my ProWriter account, will I lose my data?</h4>
				    		    		<p className="pb-4 mb-4">Any features or content that is only accessible through a ProWriter membership will become inaccessible. This includes things like the jobs board, courses, and your public portfolio.</p>
				    		    	</div>
				    		    </div>
				    		</div>	
				    	</div>
				    </section>
				    <section className="bottom">
				        <div className="container position-relative">
				    	    <div className="sub-container mx-auto">
				    		    <div className="row">
				    			    <div className="col-lg-6">
				    				    <h3 className="mb-4 text-white">Ready To Start Earning More Gigs And Money?</h3>
				    					<StartTrialButtonTwo title="Become a ProWriter Now!" clsName='d-md-block d-none position-relative px-md-4 px-2'></StartTrialButtonTwo>									
				    				</div>
				    				<div className="col-lg-6 mt-lg-0 mt-3">
				    				    <ul className="pt-3 pl-md-4">
				    		    		    <li className="text-white position-relative pl-4 mb-3"><i className="position-absolute fa fa-check"></i>Professional training on the skill employers desire!</li>
                                            <li className="text-white position-relative pl-4 mb-3"><i className="position-absolute fa fa-check"></i>Exclusive job board with trusted and vetted employers!</li>
                                            <li className="text-white position-relative pl-4 mb-3"><i className="position-absolute fa fa-check"></i>Branding and content tools to sell yourself and your content!</li>
                                            <li className="text-white position-relative pl-4 mb-3"><i className="position-absolute fa fa-check"></i>An engaged and helpful community of professional writers!</li>
                                            <li className="text-white position-relative pl-4"><i className="position-absolute fa fa-check"></i>Premium weekly newsletter with critical industry news!</li>
				    		    		</ul>
				    				</div>
				    				<div className="mt-4 col-12 d-flex justify-content-between align-items-center">
				    				    <h5 className="d-inline-block px-4 py-3 text-white">ProWriter Gives You <span className="text-decoration-underline">The Skills And Tools</span> Needed To Land Gigs</h5>
				    					<img className="w-auto" src="/images/green-circle.svg" alt="green-circle.svg"  width="82" height="82"/>
				    				</div>
				    			</div>
				    		</div>
				    	</div>
				    </section>
					<div className={this.state.mobileButtonVisible ? "sticky-start-trial d-block open" : "sticky-start-trial d-none"}>
					    <StartTrialButtonTwo title="Create Your Free Account Now" subtitle="Start With Your First Writing Job Today !" clsName='d-md-none text-center d-block position-relative px-md-4 px-2'></StartTrialButtonTwo>
					</div>
				    {this.state.video === true && this.state.videoId === "1" ? <VideoContent videoSource="https://player.vimeo.com/video/508430768" toggleVideo={this.toggleVideo}></VideoContent> : ""}
					{this.state.video === true && this.state.videoId === "2" ? <VideoContent videoSource="https://player.vimeo.com/video/508438193" toggleVideo={this.toggleVideo}></VideoContent> : ""}
					<Footer></Footer>
				</div>	
            </Fragment>
        );
    }
}

Home.contextType = AppContext;
export default Home;



// WEBPACK FOOTER //
// ./src/components/general/Home.js